<template>
  <div class="chart" :class="{ small: isSmall }">
    <strong> Globaalne fossiilkütuste tootmine </strong>

    <div class="lead">GtCO₂/a</div>

    <section>
      <img
        src="https://v.postimees.ee/graafikud/2023/fossiilkytuste/pilt.png"
      />

      <strong> Tootmislõhe </strong>

      <div class="scale-y">
        <div style="--dy: 0.11">40</div>
        <div style="--dy: 0.325">30</div>
        <div style="--dy: 0.542">20</div>
        <div style="--dy: 0.755">10</div>
        <div style="--dy: 0.97">0</div>
      </div>

      <div class="scale-x">
        <div style="--dx: 0.2">2020</div>
        <div style="--dx: 0.46">2030</div>
        <div style="--dx: 0.72">2040</div>
        <div style="--dx: 0.985">2050</div>
      </div>
    </section>

    <div class="legend">
      <div style="--c: #e41e10; --line: solid">
        <div></div>
        <div>Valitsuste plaanid ja prognoosid</div>
      </div>

      <div style="--c: #6b2f09; --line: solid">
        <div></div>
        <div>Sõnastatud poliitikad</div>
      </div>

      <div style="--c: #6b2f09; --line: dotted">
        <div></div>
        <div>Teatatud lubadused</div>
      </div>

      <div style="--c: #1c7b4c; --line: solid">
        <div></div>
        <div>Kooskõlas 2°C eesmärgiga</div>
      </div>

      <div style="--c: #858dcf; --line: solid">
        <div></div>
        <div>Kooskõlas 1,5°C eesmärgiga</div>
      </div>
    </div>

    <footer>Allikas: Production Gap Report 2023</footer>
  </div>
</template>

<style>
html.device-phone #fossiilkytuste {
  margin-left: calc(var(--root-padding) * -1);
  margin-right: calc(var(--root-padding) * -1);
  overflow: hidden;
}
</style>

<style scoped>
.chart {
  --w: v-bind(containerWidth + "px");

  width: 100%;
  display: flex;
  flex-direction: column;

  position: relative;

  font-family: GT Eesti, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: var(--text-color);

  background-color: var(--light);
  border-radius: 3px;

  box-sizing: border-box;
  padding: 2em;

  line-height: 1;
  font-size: 16px;
}

.small.chart,
.device-phone .chart {
  padding: var(--root-padding);
  border-radius: 0;

  font-size: 13px;
}

.chart > strong {
  font-size: 2em;
  line-height: 1.1;
  /*  text-wrap: balance;*/
}

.chart.small > strong {
  font-size: 1.75em;
}

.chart > .lead {
  font-weight: 300;
  font-size: 1.25em;
  line-height: 1.33;

  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

footer {
  margin-top: 0.5em;
  font-size: 1em;
  font-weight: 300;

  text-align: right;
}

.dark-theme footer,
.dark-theme .chart > .lead {
  font-weight: 400;
}

.chart.small > .lead {
}

section {
  max-width: 946px;

  position: relative;

  box-sizing: border-box;
  padding-left: 1em;
}

section img {
  max-width: 100%;

  mix-blend-mode: multiply;
}

section > strong {
  position: absolute;
  top: 32%;
  left: 67%;
  transform: translate(-50%, -50%);

  font-size: clamp(3px, calc(0.05 * var(--w)), 50px);
}

.scale-y {
  position: absolute;
  bottom: 0;
  top: 0;
  left: 0;
}

.scale-y > div {
  position: absolute;

  top: calc(var(--dy) * 100%);
  left: 0;
  width: 3ch;

  transform: translateY(-45%) translateX(-0.7ch);
  text-align: center;

  font-size: 1.25em;
  font-weight: 300;
}

.scale-x {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}

.scale-x > div {
  position: absolute;

  top: 0;
  left: calc(var(--dx) * 100%);

  transform: translateX(-50%);

  font-size: 1em;
  font-weight: 700;
  color: var(--gray);
}

.legend {
  margin-top: 2em;
  margin-bottom: 1em;

  display: flex;
  flex-direction: column;

  gap: 0.33em;

  font-size: 1.25em;
  font-weight: 300;
}

.dark-theme .legend {
  font-weight: 400;
}

.legend > div {
  display: grid;
  grid-template-columns: 3ch 1fr;
  gap: 1ch;
}

.legend > div > div:first-of-type {
  border-top: 0.33em var(--line) var(--c);

  height: 70%;
  margin-top: auto;
}

.dark-theme section img,
.dark-theme .legend > div > div:first-of-type {
  mix-blend-mode: color-dodge;
  filter: invert(1);
}
</style>

<script setup>
import {
  ref,
  computed,
  onMounted,
  onUnmounted,
  inject,
  nextTick,
  watch,
} from "vue";

//
const containerElement = inject("containerElement");
const containerWidth = ref(0);
const isSmall = computed(() => {
  return containerWidth.value < 480;
});

// *** methods ***

function onResize() {
  const bounds = containerElement.getBoundingClientRect();
  const { width } = bounds;
  containerWidth.value = width;
}

//

onMounted(() => {
  window.addEventListener("resize", onResize);
  onResize();
  nextTick(onResize);
  window.setTimeout(onResize, 1500);
});

onUnmounted(() => {
  window.removeEventListener("resize", onResize);
});
</script>
